import apiClient from "./apiClient";

export const syncTravelData = async (caseId, body) => {
  const { data } = await apiClient.post("/travel/sync", {
    case_id: caseId,
    ...body,
  });
  return data;
};

// The server stamps the purchase date — it is a server-owned column.
export const recordTravelPurchase = async (caseId) => {
  const { data } = await apiClient.post(`/travel/${caseId}/purchase`);
  return data;
};

export const fetchTravelData = async (caseId) => {
  const { data } = await apiClient.get(`/travel/${caseId}`);
  return data;
};

// The direction ("inbound" | "outbound") is a path segment. Sent empty it
// produces /premium//<id>, which matches no route and surfaces as a 404 with
// nothing to say why — so refuse here, where the cause is nameable.
const requireDirection = (direction) => {
  if (direction !== "inbound" && direction !== "outbound") {
    const message = "Travel direction is missing — answer 'Where to' first.";
    // Shaped like an API failure so the screens' error handling shows it.
    throw Object.assign(new Error(message), { response: { data: { error: message } } });
  }
  return direction;
};

export const fetchTravelPremium = async (caseId, direction) => {
  const { data } = await apiClient.post(`/premium/${requireDirection(direction)}/${caseId}`);
  return data;
};

export const finaliseTravel = async (caseId, direction) => {
  const { data } = await apiClient.post(`/finalise/${requireDirection(direction)}/${caseId}`);
  return data;
};

